import {
  Box,
  Container,
  Heading,
  Text,
  SimpleGrid,
  VStack,
  Flex,
  useColorModeValue,
  Image,
} from '@chakra-ui/react';

import serviceImage from '../assets/images/Service_image.webp';

const services = [
  {
    title: 'Maquinaria pesada e industrial',
    description: 'Excavadoras, montacargas, equipos de construcción e industria pesada para proyectos de gran escala.',
  },
  {
    title: 'Geocontenedores y Geosintéticos',
    description: 'Geocontenedores, módulos personalizados y soluciones adaptadas a necesidades específicas.',
  },
  {
    title: 'Energía solar y sistemas eléctricos',
    description: 'Paneles solares, inversores, tableros eléctricos y componentes para proyectos energéticos.',
  },
  {
    title: 'Tecnología',
    description: 'Pantallas LED, tableros publicitarios y equipos tecnológicos para instalaciones comerciales y eventos.',
  },
];

function ServicesSection() {
  const cardBg = useColorModeValue('rgba(255, 255, 255, 0.8)', 'rgba(15, 23, 42, 0.6)');
  const cardBorder = useColorModeValue('gray.200', 'whiteAlpha.200');
  const subtitleColor = useColorModeValue('gray.600', 'gray.300');
  const cardTextColor = useColorModeValue('gray.600', 'gray.400');
  const accentColor = useColorModeValue('gray.900', 'white');

  return (
    <Box id="servicios" as="section" w="full">
      <Container maxW="1120px">
        <Flex
          direction={{ base: 'column', lg: 'row-reverse' }}
          gap={10}
          align="center"
        >
          {/* Text Content - 60% */}
          <VStack align="start" spacing={6} flex="0 0 60%" maxW={{ lg: '60%' }}>
            <Heading 
              as="h2" 
              fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }} 
              fontWeight="900">
              Importamos todo lo que tu empresa necesita
            </Heading>
            <Text
              fontSize={{ base: 'lg', md: 'xl' }}
              color={subtitleColor}
              letterSpacing="wide"
              lineHeight="tall"
              pb={3}
              mb={2}
            >
              Acompañamos importaciones de todo tipo, desde equipos industriales hasta soluciones tecnológicas y energéticas. Nos adaptamos a cada proyecto, sin importar su tamaño o complejidad.
            </Text>
            <SimpleGrid columns={{ base: 1, sm: 2 }} spacing={4} w="full">
              {services.map((service) => (
                <Box
                  key={service.title}
                  bg={cardBg}
                  borderRadius="xl"
                  p={5}
                  border="1px solid"
                  borderColor={cardBorder}
                >
                  <Heading 
                    as="h3" 
                    fontSize="lg" 
                    mb={2} 
                    color={accentColor} 
                    fontWeight="900"
                  >
                    {service.title}
                  </Heading>
                  <Text color={cardTextColor} fontSize="sm">
                    {service.description}
                  </Text>
                </Box>
              ))}
            </SimpleGrid>
          </VStack>

          {/* Image - 40% */}
          <Box
            flex="0 0 40%"
            maxW={{ lg: '40%' }}
            w="full"
            h={{ base: '300px', lg: '400px' }}
            bg={cardBg}
            borderRadius="2xl"
            border="1px solid"
            borderColor={cardBorder}
            display="flex"
            alignItems="center"
            justifyContent="center"
            overflow="hidden"
          >
            {/* Placeholder - reemplazar con imagen */}
            <Image src={serviceImage} alt="Service" objectFit="cover" w="full" h="full" loading="lazy" />
          </Box>
        </Flex>
      </Container>
    </Box>
  );
}

export default ServicesSection;
